/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_AllInputs */

const en_home_quotes_all = /** @type {(inputs: Home_Quotes_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all quotes`)
};

/**
* | output |
* | --- |
* | "See all quotes" |
*
* @param {Home_Quotes_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_all = /** @type {((inputs?: Home_Quotes_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_all(inputs)
});